export class ClienteArquivo {
  public client_id_app: number;
  public nm_arquivo: string;
  public id: string;
  public dt: Date;
  public descricao: string;

  constructor() { }
}
